module.exports = __webpack_public_path__ + "static/media/Add2.64b5351e.svg";